import React from 'react';
import {
    Box,
    Input,
    Button,
    FormControl,
    FormLabel,
    Flex,
    Image,
    Text,
    Link, Icon, useColorModeValue
} from '@chakra-ui/react';
import {PiButterflyFill} from "react-icons/pi";
import {useNavigate} from "react-router-dom";

const LoginPage = () => {
    const navigate = useNavigate();
    const handleSignIn = () => {
        navigate("/");
    }
    return (
        <Flex minHeight="100vh" width="full" align="center" justifyContent="center" bgColor={useColorModeValue("gray.800","gray.200")}>
            <Box
                borderWidth={1}
                px={4}
                width="full"
                maxWidth="500px"
                borderRadius={4}
                textAlign="center"
                boxShadow="lg"
                bgColor={useColorModeValue("gray.200","gray.800")}
                // outlineColor={useColorModeValue("black","white")}
                // textColor={useColorModeValue("white","black")}
            >
                <Box p={4}>
                    <Flex width="full" justifyContent="center" gap={2} alignItems={"center"}>
                        <PiButterflyFill />
                        <Text fontSize="2xl" fontWeight="bold">Butterfly</Text>
                    </Flex>


                    <Box my={8} textAlign="left">
                        <form>
                            <FormControl>
                                <FormLabel>Username</FormLabel>
                                <Input type="text" placeholder="Enter your username" />
                            </FormControl>

                            <FormControl mt={4}>
                                <FormLabel>Password</FormLabel>
                                <Input type="password" placeholder="Enter your password" />
                            </FormControl>

                            <Link color="blue.500" alignSelf="flex-end" mt={2}>Forgot password?</Link>

                            <Button width="full" mt={4} type="submit" colorScheme="blue" onClick={handleSignIn}>Sign In</Button>
                        </form>
                    </Box>
                </Box>
            </Box>

        </Flex>
    );
};

export default LoginPage;
